module.exports = __webpack_public_path__ + "images/company/rank_medal/request_count_rank/4_071c7df7eb10fe92c72a630242efd282.png";